import styled from '@emotion/styled';
import { mainColors } from 'src/assets/colors';
import { fontWeight } from 'src/assets/fonts-config';

export const ActionsWrapper = styled('div', { label: 'ActionsWrapper' })`
    align-items: center;
    display: flex;
    gap: 8px;
`;

export const InfoWrapper = styled('div', { label: 'InfoWrapper' })`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const WelcomeBonus = styled('div', { label: 'WelcomeBonus' })`
    color: ${mainColors.default.dark};
    font-size: 14px;
    font-weight: ${fontWeight.bold};
    line-height: 1.29;
    margin-left: 32px;
    max-width: 185px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const PromoName = styled('div', { label: 'PromoName' })`
    font-size: 14px;
    line-height: 1.29;
    font-weight: ${fontWeight.regular};
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 112px;
    max-width: 112px;
`;

export const PromoInfoWrapper = styled('div', { label: 'PromoInfoWrapper' })`
    display: flex;
    margin-right: 24px;
`;
